import { SertifikatTTEInterface } from '../../../data/contracts/SertifikatTTE';
import { Endpoints } from '../../misc/Endpoints';
import { LogTTEDataMapper } from '../../../data/mappers/LogTTE';
import { LogTTE } from '../../../entities/LogTTE';
import { LogTTEPengetahuan } from '../../../entities/LogTTEPengetahuan';
import ApiService from '../../services/ApiService';

export class SertifikatTTERepository implements SertifikatTTEInterface {
  private apiService: ApiService;
  private mapper: LogTTEDataMapper;
  private endpoints: Endpoints;

  constructor(
    apiService: ApiService,
    mapper: LogTTEDataMapper,
    endpoints: Endpoints
  ) {
    this.apiService = apiService;
    this.mapper = mapper;
    this.endpoints = endpoints;
  }

  /**
   *
   * @param pelatihan_id
   * @param isTteUlang
   * @param action
   * @param userId
   * @param akun_tte_id
   */
  public async tteSertifikat(
    pelatihan_id: number,
    isTteUlang: boolean,
    action: string,
    userId: number,
    akun_tte_id: number
  ): Promise<any> {
    const headers = new Map<string, string>();

    const formData = new FormData();
    formData.append('akun_tte_id', akun_tte_id.toString());
    formData.append('pelatihan_id', pelatihan_id.toString());
    formData.append('action', action);
    if (userId !== 0) {
      formData.append('user_id', userId.toString());
    }

    const dataResponse = await this.apiService.invoke(
      'post',
      isTteUlang ? '/sertifikat/generate_ulang' : '/sertifikat/tte',
      {},
      formData,
      headers
    );
    return dataResponse;
  }

  public async logTTESertifikat(page: number, rows: number): Promise<LogTTE[]> {
    const headers = new Map<string, string>();

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.logTTESertifikat(),
      {
        page: page,
        rows: rows,
      },
      null,
      headers
    );
    return this.mapper.convertListLogTTEData(dataResponse);
  }

  public async logTTESertifikatPengetahuan(
    page: number,
    rows: number,
    activity: string
  ): Promise<LogTTEPengetahuan[]> {
    const headers = new Map<string, string>();
    const params: any = { page, rows };
    if (activity) {
      params.activity = activity;
    }

    const dataResponse = await this.apiService.invoke(
      'get',
      this.endpoints.logTTESertifikatPengetahuan(),
      params,
      null,
      headers
    );
    return this.mapper.convertListLogTTEPengetahuanData(dataResponse);
  }

  /**
   *
   * @param pelatihan_id
   * @param isTteUlang
   * @param action
   * @param userId
   * @param akun_tte_id
   * @param status_pengajuan
   * @param alasan
   */
  public async pengajuanTTESertifikat(
    pelatihan_id: number,
    isTteUlang: boolean,
    userId: number,
    akun_tte_id: number,
    status_pengajuan: string,
    alasan: string
  ): Promise<any> {
    const headers = new Map<string, string>();

    const formData = new FormData();
    if (akun_tte_id !== 0) {
      formData.append('akun_tte_id', akun_tte_id.toString());
    }
    formData.append('pelatihan_id', pelatihan_id.toString());
    if (userId !== 0) {
      formData.append('user_id', userId.toString());
    }

    if (isTteUlang) {
      formData.append('status_pengajuan', status_pengajuan);
    }

    if (alasan !== '') {
      formData.append('alasan', alasan);
    }

    const dataResponse = await this.apiService.invoke(
      'post',
      isTteUlang
        ? `/${this.endpoints.pengajuanTTESertifikat()}/${pelatihan_id}`
        : this.endpoints.pengajuanTTESertifikat(),
      {},
      formData,
      headers
    );
    return dataResponse;
  }
}
